import template_simple_article from "./template_simple_article.json";
import template_newsletter from "./template_newsletter.json";
import template_triple_product_list from "./template_triple_product_list.json";

export const TEMPLATES = [
  template_simple_article,
  template_newsletter,
  template_triple_product_list,
];
